/** Сегодняшняя дата в местном поясе, YYYY-MM-DD. */
export function todayISO(): string {
  const d = new Date();
  // toISOString() дал бы дату по UTC и уводил бы вечер в следующие сутки
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Сдвиг даты на указанное число суток. */
export function shiftISO(date: string, days: number): string {
  const [y, m, d] = date.split('-').map(Number) as [number, number, number];
  const shifted = new Date(y, m - 1, d + days);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${shifted.getFullYear()}-${pad(shifted.getMonth() + 1)}-${pad(shifted.getDate())}`;
}

/**
 * Подпись дня для шапки: близкие дни называем словами, остальные - датой.
 */
export function dayLabel(date: string, today = todayISO()): string {
  if (date === today) return 'Сегодня';
  if (date === shiftISO(today, -1)) return 'Вчера';
  if (date === shiftISO(today, 1)) return 'Завтра';

  const [y, m, d] = date.split('-').map(Number) as [number, number, number];
  const value = new Date(y, m - 1, d);
  return value.toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    ...(String(y) === today.slice(0, 4) ? {} : { year: 'numeric' }),
  });
}
